/* Shared audio player controller — multi-instance safe, double-init guarded. */
(function () {
  function initPlayers() {
    document.querySelectorAll('[data-sinead-audio]').forEach(function (player) {
      if (player.dataset.syInit) return;
      player.dataset.syInit = '1';

      var audio = player.querySelector('[data-audio]');
      var playBtn = player.querySelector('[data-play]');
      var playIcon = player.querySelector('.sinead-audio-player__icon--play');
      var pauseIcon = player.querySelector('.sinead-audio-player__icon--pause');
      var scrubber = player.querySelector('[data-scrubber]');
      var timeEl = player.querySelector('[data-time]');
      var muteBtn = player.querySelector('[data-mute]');
      var volSlider = player.querySelector('[data-volume]');
      var wave1 = player.querySelector('[data-vol-wave-1]');
      var wave2 = player.querySelector('[data-vol-wave-2]');
      var mutedLine = player.querySelector('[data-muted-line]');

      if (!audio || !playBtn) return;

      function fmt(s) {
        var m = Math.floor(s / 60);
        var sec = Math.floor(s % 60).toString().padStart(2, '0');
        return m + ':' + sec;
      }

      function updateProgress() {
        if (!audio.duration) return;
        var pct = (audio.currentTime / audio.duration) * 100;
        if (scrubber) scrubber.value = pct;
        player.style.setProperty('--sinead-audio-progress', pct + '%');
        if (timeEl) timeEl.textContent = fmt(audio.currentTime);
      }

      playBtn.addEventListener('click', function () {
        if (audio.paused) {
          audio.play();
          playIcon.style.display = 'none';
          pauseIcon.style.display = 'block';
          player.classList.add('is-playing');
        } else {
          audio.pause();
          playIcon.style.display = 'block';
          pauseIcon.style.display = 'none';
          player.classList.remove('is-playing');
        }
      });

      audio.addEventListener('timeupdate', updateProgress);

      audio.addEventListener('ended', function () {
        playIcon.style.display = 'block';
        pauseIcon.style.display = 'none';
        player.classList.remove('is-playing');
        player.style.setProperty('--sinead-audio-progress', '0%');
        if (scrubber) scrubber.value = 0;
        if (timeEl) timeEl.textContent = '0:00';
      });

      if (scrubber) {
        scrubber.addEventListener('input', function () {
          if (!audio.duration) return;
          audio.currentTime = (scrubber.value / 100) * audio.duration;
        });
      }

      if (muteBtn) {
        muteBtn.addEventListener('click', function () {
          audio.muted = !audio.muted;
          player.classList.toggle('is-muted', audio.muted);
          if (wave1) wave1.style.display = audio.muted ? 'none' : '';
          if (wave2) wave2.style.display = audio.muted ? 'none' : '';
          if (mutedLine) mutedLine.style.display = audio.muted ? 'block' : 'none';
        });
      }

      if (volSlider) {
        volSlider.addEventListener('input', function () {
          audio.volume = volSlider.value;
          if (audio.muted && volSlider.value > 0) {
            audio.muted = false;
            player.classList.remove('is-muted');
            if (wave1) wave1.style.display = '';
            if (wave2) wave2.style.display = '';
            if (mutedLine) mutedLine.style.display = 'none';
          }
        });
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initPlayers);
  } else {
    initPlayers();
  }
})();
